import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Button, Alert, Col, Row, Panel } from 'react-bootstrap';
import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import moment from 'moment';
import * as Actions from 'actions';
import * as Permissions from 'permissions';
import { connect } from 'react-redux';
import { VIEW_CANVASSING_REPORT } from 'permissions';
import { browserHistory } from 'react-router';
import { CanvassingDoughnutCharts, LoadingSpinner } from 'components';
import _ from 'lodash';

import 'bootstrap-daterangepicker/daterangepicker.css';

const normalizeTableData = data => {
  for(const obj of data) {
    for(const key in obj) {
      if(/^\s*$/.test(key)) {
        obj['(no name)'] = obj[key];
        delete obj[key];
      }
    }
  }
}

import * as Api from 'api';
import { ContainerLoader } from '../';

class CanvassingReport extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      table_data: [],
      chart_data: {},
      fetching : true,
      start_date : moment().subtract(29, 'days'),
      end_date : moment(),
      show_graphs: true
    }

    this.mounted = false;

    this.getReportData = this.getReportData.bind(this);
    this.handleApply = this.handleApply.bind(this);
  }

  getReportData() {
    let {start_date, end_date} = this.state;
    const start_date_str = moment.isMoment(start_date) ? start_date._d : start_date;
    const end_date_str = moment.isMoment(end_date) ? end_date._d : end_date;
    this.setState({ fetching: true });
    Api.getMarkersReportData(start_date_str, end_date_str)
    .then(result => {
      const { table_data, chart_data } = result.report_data;
      normalizeTableData(table_data);
      this.mounted ? this.setState({ chart_data, table_data, fetching: false }) : null;
    }).catch(error => {
      this.mounted ? this.setState({ fetching: false, error }) : null;
      console.error(error);
    })
  }

  handleApply(p, picker) {
    // debugger
    this.setState({
      start_date : picker.startDate,
      end_date : picker.endDate,
    }, () => {
      this.getReportData()
    })
  }

  componentWillMount() {
    const { user } = this.props.users;
    if(!this.props.hasPermission(VIEW_CANVASSING_REPORT)) {
      browserHistory.goBack();
    }
    if(!this.props.canvassing.marker_types_initialized) {
      this.props.initMapMarkerTypes();
    }
    this.getReportData();
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    let start = this.state.start_date.format('MM/DD/YYYY');
    let end = this.state.end_date.format('MM/DD/YYYY');
    let label = `${start} - ${end}`;

    const table_data = this.state.table_data || [];
    const columns = [
      { header : 'Name', accessor : 'name', footer : 'Totals :' },
      { header : 'Email', accessor : 'email' },
      ...Object.keys(table_data[0] || {})
      .filter(key => key != 'email' && key != 'name')
      .sort((a, b) => a == 'Total' ? 1 : -1)
      .map(key => ({
        header : key,
        accessor : key,
        render: ({ value }) => <span className="pull-right">{value}</span>,
        footer : ({ data }) => <span className="pull-right">{data.map(d => d[key]).reduce((a,b) => a + b, 0)}</span>
      })),
    ];

    if(!this.props.hasPermission(Permissions.VIEW_CANVASSING_REPORT)) {
      return <Panel bsStyle={'danger'} header={<h3>Access Denied</h3>}>
        <p>You do not have permission to view canvassing reports. Permission: ({Permissions.VIEW_CANVASSING_REPORT.split('/').filter(f => f).join(' -> ')})</p>
      </Panel>
    }

    return (
      <div className='canvassing-report-container'>
        <div className='animated fadeInDown'>
          <CanvassingDoughnutCharts
            chart_data={this.state.chart_data}
            fetching={this.state.fetching}
          />
        </div>
        <div className='animated fadeInUp'>
          <Panel
            className='marker-report-container animated fadeInDown'
            header={<h3>Canvassing Markers</h3>}
            >
            {this.state.fetching ? (
              <LoadingSpinner />
            ) : (
              <div className='canvassing-report-table-body-container'>
                <Row>
                  <Col xs={12}>
                    {this.state.error ? (
                      <Alert bsStyle='danger'>
                        <div>
                          <Button onClick={e => this.setState({ error: null })} bsStyle="default" className="pull-right"><i className="fa fa-close"></i></Button>
                          {this.state.error.message}
                        </div>
                      </Alert>
                    ) : null}
                  </Col>
                  <Col xs={12}>
                    <label htmlFor='date-picker-text'>Choose a Date Range</label>
                  </Col>
                  <Col md={6} xs={12}>
                    <DatetimeRangePicker
                      startDate={this.state.start_date}
                      endDate={this.state.end_date}
                      onApply={this.handleApply}>
                      <div className='input-group mb-md'>
                        <input
                          name='date-picker-text'
                          type='text'
                          className='form-control'
                          value={label}
                        />
                        <span className='input-group-btn'>
                          <Button className='default date-range-toggle'>
                            <i className='fa fa-calendar'/>
                          </Button>
                        </span>

                      </div>
                    </DatetimeRangePicker>
                  </Col>
                  <Col md={6}>
                    <Button onClick={e => {
                      this.getReportData();
                    }} bsStyle='primary'>
                      {this.state.fetching ? <i className="fa fa-refresh fa-spin"></i> : <i className='fa fa-refresh'/> }
                    </Button>
                  </Col>
                </Row>
                <ReactTable
                  columns={columns}
                  data={this.state.table_data}
                  className='-striped'
                />
              </div>
            )}
          </Panel>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ users, canvassing }) => ({ users, canvassing });

export default connect(mapStateToProps, Actions)(CanvassingReport);



// WEBPACK FOOTER //
// ./src/browser/components/reports/canvassing/canvassing-report.js